import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Chip,
  Tabs,
  Tab,
  Button,
  Stack,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import JobPopupFlow from "./JobDetails/JobFlowPopup";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const categories = [
  "All",
  "Web Developer",
  "Digital Marketing",
  "Graphic Designer",
  "Motion Designer",
  "Sales",
  "Management",
];

const jobs = [
  {
    category: "Web Developer",
    level: "Mid Level",
    title: "Frontend Developer",
    location: "Hyderabad",
    experience: "2–4 Years",
    salary: "₹6L – ₹12L",
    desc: "Build modern responsive web applications.",
    responsibilities: [
      "Develop UI using React",
      "Optimize performance",
      "Work with APIs",
    ],
  },
  {
    category: "Digital Marketing",
    level: "Senior Level",
    title: "SEO Specialist",
    location: "Hyderabad",
    experience: "3–6 Years",
    salary: "₹5L – ₹10L",
    desc: "Drive organic growth and SEO strategy.",
    responsibilities: [
      "Keyword research",
      "Content optimization",
      "Analytics tracking",
    ],
  },
];

const OpenRoles: React.FC = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [selectedJob, setSelectedJob] = useState<any>(null);

  const filteredJobs =
    activeTab === "All"
      ? jobs
      : jobs.filter((job) => job.category === activeTab);

  return (
    <Box
      sx={{
        py: 12,
        background:
          "linear-gradient(180deg, #f8fbff 0%, #eef5fc 100%)",
      }}
    >
      <Container maxWidth="lg">

        {/* TITLE */}
        <Typography
          sx={{
            fontSize: { xs: "2rem", md: "3rem" },
            fontWeight: 700,
            color: "#0f63a5",
            mb: 5,
          }}
        >
          Open Roles
        </Typography>

        {/* 🔥 LUXURY TABS */}
        <Box
          sx={{
            mb: 6,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              background: "rgba(255,255,255,0.6)",
              backdropFilter: "blur(12px)",
              borderRadius: "40px",
              px: 1,

              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {categories.map((cat) => (
              <Tab
                key={cat}
                value={cat}
                label={cat}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  borderRadius: "30px",
                  px: 3,
                  minHeight: "42px",

                  "&.Mui-selected": {
                    background:
                      "linear-gradient(90deg,#0f63a5,#42a5f5)",
                    color: "#fff",
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>

        {/* 🔥 CARDS */}
        <Grid container spacing={4}>
          {filteredJobs.map((job, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  p: 4,
                  borderRadius: "20px",

                  // ✨ GLASS + GRADIENT BORDER
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(255,255,255,0.6))",
                  backdropFilter: "blur(10px)",

                  border: "1px solid rgba(15,99,165,0.15)",
                  boxShadow:
                    "0 15px 40px rgba(15,99,165,0.08)",

                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  textAlign:"start",
                  transition: "all 0.4s ease",

                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow:
                      "0 25px 60px rgba(15,99,165,0.18)",
                  },
                }}
              >
                {/* TOP CONTENT */}
                <Box>
                  <Chip
                    label={job.level}
                    sx={{
                      mb: 2,
                      background: "#e6f0fa",
                      color: "#0f63a5",
                      fontWeight: 500,
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: "1.4rem",
                      fontWeight: 700,
                      mb: 1,
                      color: "#111",
                    }}
                  >
                    {job.title}
                  </Typography>

                  {/* 🔥 FLEX ROW (EXPERIENCE + LOCATION) */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      flexWrap: "wrap",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <WorkOutlineIcon sx={{ fontSize: 18, color: "#0f63a5" }} />
                      <Typography variant="body2">{job.experience}</Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <LocationOnIcon sx={{ fontSize: 18, color: "#0f63a5" }} />
                      <Typography variant="body2">{job.location}</Typography>
                    </Box>
                  </Box>

                  <Typography
                    sx={{
                      color: "#555",
                      fontSize: "0.95rem",
                      lineHeight: 1.6,
                    }}
                  >
                    {job.desc}
                  </Typography>
                </Box>

                {/* CTA BUTTON */}
                <Button
                  variant="contained"
                  onClick={() => setSelectedJob(job)}
                  sx={{
                    mt: 3,
                    borderRadius: "30px",
                    textTransform: "none",
                    fontWeight: 600,
                    background:
                      "linear-gradient(90deg,#0f63a5,#42a5f5)",
                    boxShadow:
                      "0 10px 30px rgba(15,99,165,0.3)",

                    "&:hover": {
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Apply Now
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* POPUP FLOW */}
      <JobPopupFlow
        job={selectedJob}
        onClose={() => setSelectedJob(null)}
      />
    </Box>
  );
};

export default OpenRoles;